module.exports = __webpack_public_path__ + "static/media/gilead.550bfdb5.png";